/* eslint-disable no-script-url */
import React from "react";
import "./NavigationBar.css";

const NavigationBar = (props) => {
  const { _toggleOpen, menuClass, menuList, cssClass, onMenuclick } = props;
  const listItems = menuList.map((menu) => (
    <li className="nav-item active" key={menu.text}>
      <a
        className="nav-link"
        href="Javascript:void(0);"
        onClick={onMenuclick(menu.href)}
      >
        <i className={menu.icon}></i> {menu.text}
      </a>
    </li>
  ));
  return (
    <nav className={cssClass}>
      <div className="container">
        <a className="navbar-brand" href="#home">
          <img
            alt="Logo"
            aria-hidden="true"
            width="42"
            height="42"
            src="images/walmart-logo.png"
          />
          <span className="logo-title">Vacuum Accessory Finder</span>
        </a>
        <button
          onClick={_toggleOpen}
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span>
            <i className="fa fa-bars fa-2x"></i>
          </span>
        </button>
        <div className={menuClass} id="navbarResponsive">
          <ul className="navbar-nav ml-auto">{listItems}</ul>
        </div>
      </div>
    </nav>
  );
};
export default NavigationBar;
